import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-modal-messages',
  templateUrl: './modal-messages.component.html',
  styleUrls: []
})
export class ModalMessagesComponent implements OnInit {

  constructor() {
    // This is intentional
  }

  currentIndex: number = 0
  messageList: Array<string> = []

  msgMatriculaActiva: string = 'De acuerdo a nuestros registros tienes una matrícula activa en una de nuestras instituciones, sin embargo, podrás continuar y completar tu matrícula y posteriormente un ejecutivo de admisión tomará contacto contigo para regularizar la situación de tu matrícula anterior.'

  ngOnInit(): void {
    // This is intentional
  }

  addMessage(message: string) {
    this.messageList.push(message)
  }

  getMessagesLength() {
    return this.messageList.length
  }

  show() {
    $('#modalMessages').modal('show');
  }

  goToPrev() {
    this.currentIndex--
  }

  goToNext() {
    this.currentIndex++
  }

}
